import React from 'react'

const Footer = () => (
  <footer id="footer">
    <div className="copyright"><span>{'\u00A9'}</span> 2019 falcon.code</div>
  </footer>
)

export default Footer
